import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LowPriorityIcon(props: IconProps) {
    return <Icon {...props} iconKey={"low_priority"}/>
}
